<template>
  <div class="home">
    <div class="content-home">
      <Banner :title="banner.title" :image="banner.image"/>
      <div class="great-prize container">
        <h2>Foi apurado o grande vencedor de um automóvel Volkswagen T-Roc</h2>
        <p>O vencedor é o Sr José Alberto Martins dos Santos com uma participação no estabelecimento "O Jaime" em Odemira. <br>  
        <span>Parabéns ao feliz contemplado.</span><br>
        O vencedor será contactado pela Delta, a fim de procedermos à entrega do seu prémio.</p>
      </div>
      <Prizes :prizes="prizes"/>
      <HowItWorks :title="howitworks_title" :cards="cards"/>
      <App :image="app.image" :text="app.text" :title="app.title"/>
      <Register :logos="logos" :text="register_text"/>

    </div>
  </div>
</template>

<script>
import Banner from './components/Banner.vue'
import Prizes from './components/Prizes.vue'
import HowItWorks from './components/HowItWorks.vue'
import App from './components/App.vue'
import Register from './components/Register.vue'
import axios from 'axios'


export default {
  name: 'Home',
  data() {
    return {
      banner: {
        title: '',
        image: ''
      },
      prizes:{
        title: '',
        image: '',
        description: ''
      },
      howitworks_title: '',
      cards: [],
      app: {
        image: '',
        text: '',
        title: ''
      },
      logos: [],
      register_text: ''
    
    }
  },
  components: {
    Banner,
    Prizes,
    HowItWorks,
    App,
    Register
  },
  async mounted() {
    axios.get("/api/v1/homepage")
      .then((resp) => {
        this.banner.title = resp.data.banner_text
        this.banner.image = resp.data.banner_image
        this.prizes.title = resp.data.prizes_title
        this.prizes.image = resp.data.prizes_image
        this.prizes.description = resp.data.prizes_description
        this.howitworks_title = resp.data.howitworks_title
        this.cards = resp.data.howitworks_card
        this.app.image = resp.data.app_image
        this.app.text = resp.data.app_text
        this.app.title = resp.data.app_title
        this.logos = resp.data.logo_path
        this.register_text = resp.data.register_text
      })
      .catch((error) => {
        console.log(error);
      });

      if(localStorage.getItem('scrollToElement')) {
      setTimeout(() => {
        this.$scrollTo('#login', 800, { easing: 'ease-in-out' });
        localStorage.removeItem('scrollToElement');
      }, 2000); 
    }
  },
}
</script>
<style lang="scss">
.content-home {
  width: 100%;
  height: 100%;
}

.great-prize {
  margin-top: 100px;
  color: black;
  padding: 20px;
  text-align: left;
  h2 {
    color: black;
    font-size: 54px;
    font-family: 'Font Bold';
    text-transform: uppercase;
    margin-bottom: 10px;
    @media screen and (max-width: 992px) {
      font-size: 40px;
    }
  }
  p {
    font-size: 24px;
    line-height: 40px;
    @media screen and (max-width: 992px) {
      font-size: 20px;
    }
    span {
      font-size: 34px;
      font-weight: bold;
      @media screen and (max-width: 992px) {
        font-size: 24px;
      }
    }
  }
}

</style>
